/**
 *
 */
const minLengthWithoutWhiteSpace = (length) => (v) => {
    if (v && typeof v === 'string') {
        const result = v.replace(/\s+/g, '')
        if (result.length < length) {
            return `This field must contain at least ${length} characters`
        }
    }
    return true
}

/**
 *
 */
export {
    minLengthWithoutWhiteSpace
}
